import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 20,
    },
  },
})

export * from "./queries/advertisementQueries"
export * from "./queries/enrolledRoundsQueries"
export * from "./queries/feedbackQueries"
export * from "./queries/homepageQueries"
export * from "./queries/notificationQueries"
export * from "./queries/profileInfoQueries"
export * from "./queries/profileQueries"
export * from "./queries/projectsQueries"
export * from "./queries/settingsQueries"
export * from "./queries/skillsQueries"
export * from "./queries/surveyQueries"
export * from "./queries/ticketQueries"
export * from "./queries/achievementQueries"
